<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :title="line.id ? '编辑' : '新建'"
    width="1200px"
    top="5vh"
    @close="resetForm"
  >
    <el-form ref="form" :model="line" :rules="ruleValidate" label-width="150px" label-suffix=" :">
      <div class="fm-section-title">编码标识</div>
      <el-row :gutter="10">
        <el-col v-if="line.id" :span="6">
          <el-form-item label="产线编码">
            <el-input v-model="line.lineCode" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="产线全称" prop="lineName">
            <el-input v-model="line.lineName" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="产线简称">
            <el-input v-model="line.lineShortName" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="英文名称">
            <el-input v-model="line.lineEnglishName" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="ERP编码">
            <el-input v-model="line.lineERPCode" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="WMS编码">
            <el-input v-model="line.lineWMSCode" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="WCS编码">
            <el-input v-model="line.lineWCSCode" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="SCADA编码">
            <el-input v-model="line.lineSCADACode" />
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">归属与分类</div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="所属车间" prop="workshopID">
            <el-input v-model="workshopName" placeholder="请选择所属车间" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.workshopSelect.open()"></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="产线类型" prop="lineType">
            <el-select v-model="line.lineType" clearable>
              <el-option v-for="item in lineTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="产线状态" prop="lineStatus">
            <el-select v-model="line.lineStatus" clearable>
              <el-option v-for="item in lineStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="全自动产线">
            <el-radio-group v-model="line.isAutoLine">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="半自动产线">
            <el-radio-group v-model="line.isSemiAuto">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="批量间断线">
            <el-radio-group v-model="line.isBatchLine">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="连续流水线">
            <el-radio-group v-model="line.isFlowLine">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">环境配置</div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="继承车间洁净配置">
            <el-radio-group v-model="line.inheritCleanConfig">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="自定义洁净等级">
            <el-input v-model="line.customCleanLevel" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="自定义温度(℃)">
            <el-input-number v-model="line.customTemp" :min="-50" :max="100" controls-position="right" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="自定义湿度(%RH)">
            <el-input-number v-model="line.customHumidity" :min="0" :max="100" controls-position="right" />
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">人员配置</div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="线长">
            <el-input v-model="line.lineLeaderName" placeholder="请输入线长姓名" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="副线长">
            <el-input v-model="line.helperMgrName" placeholder="请输入副线长姓名" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="检验员">
            <el-input v-model="line.qualityInspectorName" placeholder="请输入检验员姓名" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="维修员">
            <el-input v-model="line.maintainerName" placeholder="请输入维修员姓名" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="标准定员">
            <el-input-number v-model="line.standardStaffNum" :min="0" controls-position="right" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="最大容纳人数">
            <el-input-number v-model="line.maxStaffNum" :min="0" controls-position="right" />
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">质量管控</div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="关键管控产线">
            <el-radio-group v-model="line.isKeyLine">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="强制首件检验">
            <el-radio-group v-model="line.needFirstCheck">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="在线自动检测">
            <el-radio-group v-model="line.needOnlineTest">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="IPQC巡检间隔(分钟)">
            <el-input-number v-model="line.ipqcIntervalMin" :min="0" controls-position="right" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="追溯等级">
            <el-select v-model="line.traceLevel" clearable>
              <el-option v-for="item in traceLevelOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">备注</div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="产线备注">
            <el-input v-model="line.remark" type="textarea" :rows="2" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="扩展字段">
            <el-input v-model="line.extendJson" type="textarea" :rows="2" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <CommonSelect
      ref="workshopSelect"
      title="选择车间"
      url="fm/workshop"
      :columns="workshopColumns"
      :search-items="workshopSearchItems"
      :filter="workshopFilter"
      @select="selectWorkshop"
    />

    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CommonSelect from "../CommonSelect";

export default {
  components: { CommonSelect },
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      workshopName: "",
      workshopFilter: {
        workshopCode: "",
        workshopName: "",
      },
      workshopSearchItems: [
        { key: "workshopCode", label: "车间编码", placeholder: "请输入车间编码" },
        { key: "workshopName", label: "车间全称", placeholder: "请输入车间全称" },
      ],
      workshopColumns: [
        { title: "车间编码", key: "workshopCode", width: 120, align: "center" },
        { title: "车间全称", key: "workshopName" },
        { title: "车间简称", key: "workshopShortName", width: 120 },
        { title: "操作", slot: "action", width: 80, align: "center" },
      ],
      lineTypeOptions: [
        { label: "组装", value: 1 },
        { label: "测试", value: 2 },
        { label: "发料", value: 3 },
        { label: "包装", value: 4 },
        { label: "发货前处理", value: 5 },
        { label: "老化", value: 6 },
      ],
      lineStatusOptions: [
        { label: "停用封存", value: 0 },
        { label: "正常运行", value: 1 },
        { label: "检修停机", value: 2 },
        { label: "改造调试中", value: 3 },
      ],
      traceLevelOptions: [
        { label: "简易追溯", value: 1 },
        { label: "完整工单追溯", value: 2 },
        { label: "全设备参数采集追溯", value: 3 },
      ],
      line: {},
      ruleValidate: {
        lineName: { required: true, message: "请输入产线全称", trigger: "blur" },
        workshopID: { required: true, message: "请选择所属车间", trigger: "change" },
        lineType: { required: true, message: "请选择产线类型", trigger: "change" },
        lineStatus: { required: true, message: "请选择产线状态", trigger: "change" },
      },
    };
  },
  methods: {
    resetForm() {
      this.$refs.form && this.$refs.form.resetFields();
    },
    open(row) {
      this.dialogVisible = true;
      this.workshopName = row ? row.workshopName || "" : "";
      this.line = Object.assign(
        {
          id: undefined,
          factoryID: 0,
          workshopID: 0,
          lineCode: "",
          lineERPCode: "",
          lineWMSCode: "",
          lineWCSCode: "",
          lineSCADACode: "",
          lineName: "",
          lineShortName: "",
          lineEnglishName: "",
          lineType: 1,
          lineSubType: undefined,
          isAutoLine: false,
          isSemiAuto: false,
          isBatchLine: false,
          isFlowLine: true,
          inheritCleanConfig: true,
          customCleanLevel: "",
          customTemp: undefined,
          customHumidity: undefined,
          standardTaktSec: undefined,
          standardHourOutput: undefined,
          standardDayOutput: undefined,
          maxHourOutput: undefined,
          minBatchQty: undefined,
          lineCapacityWeight: undefined,
          lineLeaderID: undefined,
          lineLeaderName: "",
          helperMgrID: undefined,
          helperMgrName: "",
          qualityInspectorID: undefined,
          qualityInspectorName: "",
          maintainerID: undefined,
          maintainerName: "",
          standardStaffNum: undefined,
          maxStaffNum: undefined,
          inheritShift: true,
          customShiftNum: undefined,
          allowOvertime: true,
          singleShiftWorkMin: undefined,
          supportAGV: true,
          agvTransferMode: 1,
          lineSideWarehouse: true,
          palletCycleUse: true,
          isKeyLine: false,
          needFirstCheck: true,
          ipqcIntervalMin: undefined,
          needOnlineTest: true,
          traceLevel: 2,
          collectEnable: true,
          collectIP: "",
          collectPort: undefined,
          protocolType: 1,
          collectCycleSec: 5,
          lineLength: undefined,
          lineWidth: undefined,
          standardPowerPerHour: undefined,
          lineStatus: 1,
          putIntoUseDate: "",
          overhaulStartDate: "",
          scrapDate: "",
          remark: "",
          extendJson: "",
        },
        row || {}
      );
    },
    selectWorkshop(row) {
      this.line.workshopID = row.id;
      this.workshopName = row.workshopName;
    },
    submitHandle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .save("basic", "fm/production-mangeline", this.line)
            .then((resp) => {
              this.submitLoading = false;
              if (resp.success) {
                this.$emit("save-success");
                this.$message.success(this.line.id ? "编辑成功" : "添加成功");
                this.dialogVisible = false;
              }
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.fm-section-title {
  font-weight: bold;
  padding: 10px 0 5px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e8e8e8;
  color: #409eff;
}
</style>
